const dashboard = {
  basicInformation: "Basic Information",
  manufacturer: "Manufacturer",
  reliabilityResume: "Reliability Resume",
  theLastReliability: "The Last Reliability Report was",
  meanTimeBetweenFailure: "Mean Time Between Failure",
  moreMeanTimeBetweenFailure:
    "This metric is the average length of operating time between failures for an asset or component.",
  mechanicalAvailability: "Mechanical Availability",
  moreMechanicalAvailability:
    "The percentage of time that the asset is capable of performing its intended function (uptime plus idle time).",
  utilizationTime: "Utilization Time",
  moreUtilizationTime:
    "Time when the asset is scheduled to run divided by total available time, expressed as a percentage.",

  operatingTime: "Operating Time",
  moreOperatingTime:
    "An interval of time during which the asset or component is performing its required function.",
  totalDowntime: "Total Downtime",
  moreTotalDowntime:
    " The amount of time an asset is not capable of running. The sum of  scheduled downtime and unscheduled downtime.",
  model: "Model",
  eventManager: "Event Manager",
  conditionMonitoringModule: "Condition Monitoring Module",
  machineHealthIndex: "Machine Health Index",
  mechanincalCondition: "Equipment Operating condition",
  reliabilitySummary: "Reliability Summary",
  mechanincalConditionOverTime: "Equipment Operating Condition Over Time",
  ago: "ago",
  hours: "hours",
  dashboard: "Dashboard",
  ranges: "Ranges",
  operationalValues: "Operational Values",
  graphics: "Graphics",
  inspections: "Inspections",
  reliability: "Reliability",
  documents: "Documents",
  repairLog: "repairLog",
  equipmentDocs: "Equipment Docs",
  datasheet: "Datasheet",
  drawings: "Drawings",
  addMultimedia: "Add Multimedia",
  fileInput: "File Input",
  selectEquipmentsVariables: "Select equipment's variables",
  updateRanges: "Update Ranges",
  canYouConfirm: "Can you confirm that all the fields are correct?",
  checkFields: "Check Fields"
};
export default dashboard;
